export default __webpack_public_path__ + "static/contact-c09b4041f4d25ea6ede518aec0064a13.jpg";